module.exports = __webpack_public_path__ + "img/SA-1440.35c9d8c1.jpg";